import React, { useEffect, useState } from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import "./App.css";
import styled from "styled-components";
import Main from "./pages/Main";
import { pageSetting } from "./styles/theme";
import Header from "./components/Header";
import RequestBugBounty from "./pages/RequestBugBounty";
import Dashboard from "./pages/Dashboard";
import BountyList from "./pages/BountyList";
import ViewDetail from "./pages/ViewDetail";
import Submissions from "./pages/Submissions";
import Report from "./pages/Report";
import BugReport from "./pages/BugReport";
import HunterDashboard from "./pages/HunterDashboard";
import { connects } from "./lib/metamask";
import { useDispatch, useSelector } from "react-redux";
import { updateProjectList } from "./store/reducers/projectList";
import Loading from "./components/Loading";
import { RootState } from "./store/reducers";
import { updateLoading } from "./store/reducers/loading";

function App() {
	const dispatch = useDispatch();
	const [init, setInit] = useState(false);
	const { loading } = useSelector((state: RootState) => state.loading);

	const getProjectLength = async () => {
		dispatch(updateLoading(true));
		const projectLength = await connects.rpcProvider["BaroqueWorks"].getProjectLength();
		dispatch(updateLoading(false));

		return projectLength;
	};

	const setInitContract = async () => {
		connects.init();
		setInit(true);
	};

	const getProjectList = async () => {
		const projectLength = await getProjectLength();
		const parseNumLength = Number(projectLength.toString());
		let lists: any = [];
		for (let i = 1; i <= parseNumLength; i++) {
			await connects.rpcProvider["BaroqueWorks"].getProject(i).then((res: any) => {
				const { id, proposer, project, baseBounty, rewardBounty, members, createAt, deadline } =
					res;

				const projectItem = {
					id: id.toString(),
					proposer: proposer.toString(),
					project,
					baseBounty: baseBounty.toString(),
					rewardBounty: rewardBounty.toString(),
					members: members.toString(),
					createAt: createAt.toString(),
					deadline: deadline.toString(),
				};
				lists.push(projectItem);
			});
		}
		dispatch(updateProjectList(lists));
	};

	//contract connect init
	useEffect(() => {
		if (!init) {
			// setInitContract()
			// getProjectList()
		}
	}, []);

	return (
		<AppSection>
			<BrowserRouter>
				{loading && <Loading />}
				<Header />
				<Routes>
					<Route path="/" element={<Main />}></Route>
					<Route path="/requestBugBounty" element={<RequestBugBounty />}></Route>
					<Route path="/bountyList" element={<BountyList />}></Route>
					<Route path="/dashboard" element={<Dashboard />}></Route>
					<Route path="/hunter" element={<HunterDashboard />}></Route>
					<Route path="/submissions" element={<Submissions />}></Route>
					{/* <Route path="/detail/*" element={<ViewDetail />}></Route> */}
					{/* <Route path="/report/*" element={<Report />}></Route> */}
					{/* <Route path="/bugReport/*" element={<BugReport />}></Route> */}
					<Route path="*" element={<>Not Found</>}></Route>
				</Routes>
			</BrowserRouter>
		</AppSection>
	);
}

const AppSection = styled.main`
	${pageSetting}
`;

export default App;
